import React, {FC} from 'react';
import { useTranslation } from "react-i18next";
import Modal from "../../../../shared/modal/modal";
import styles from './report-success-modal.module.scss'
import success from '../../../../images/success.svg'
import Button from "../../../ui-kit/button/button";
import {getReportDocument} from "../../../../services/api";

interface ReportSuccessModalProps {
    onClose: () => void;
    cityName: string;
    reportId: number;
}

const ReportSuccessModal: FC<ReportSuccessModalProps> = ({ onClose, cityName, reportId }) => {
    const { t } = useTranslation();

    const handleDownload = async (type: 'pdf' | 'word') => {
        onClose();

        try {
            await getReportDocument(reportId, type);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Modal closeClass={styles.closeBtn} onClose={onClose}>
            <div className={styles.modalWrapper}>
                <h2 className={styles.title}>{t('report-success-modal.title')}</h2>
                <img className={styles.img} src={success} alt={t('report-success-modal.successAlt')} />
                <span className={styles.description}>
                    {t('report-success-modal.description', {cityName})}
                </span>
                <div className={styles.groupBtn}>
                    <Button onClick={() => handleDownload('pdf')} type='primary'>
                        {t('report-success-modal.downloadPdf')}
                    </Button>
                    <Button onClick={() => handleDownload('word')} type='outline'>
                        {t('report-success-modal.downloadWord')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ReportSuccessModal;
